/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 1/9/20
 * Time: 9:33 AM
 */
import React, {Component} from 'react';
import './VisitorForward_.scss';
import {Col, Row} from "reactstrap";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import {Button, Checkbox, Form, Icon, Button as SementicBtn} from "semantic-ui-react";
import regis_icon from "../../../assets/img/registration/registration.png";
import queryString from "query-string";
import JWT_Decode from "jwt-decode";
import * as EmailValidator from "email-validator";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import axios from "../../../axios/axios_visitortag";
import success_icon from "../../../assets/img/sweet/success.svg";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import apiConfig from "../../../axios/axios_api_services";

class App extends Component {
  state = {
    access: true,
    isTerms: false,
    token: "",
    email: '',
    forward_emails: [
      {
        condition: false,
        value: ""
      }
    ],
  };
  addUser = () => {
    let forward_emails = this.state.forward_emails;
    forward_emails.push({
      condition: false,
      value: ""
    });

    this.setState({
      [forward_emails]: forward_emails
    })
  };

  handleChange = (index, name) => event => {
    let value = event.target.value;

    let forward_emails = this.state.forward_emails;
    forward_emails[index].value = value;
    forward_emails[index].condition = EmailValidator.validate(value);

    this.setState({
      [name]: forward_emails
    })
  };
  checkQueryString = () => {
    let queryParams = queryString.parse(window.location.search);
    let queryStringParam = queryParams.bWeu4e;

    if (queryStringParam === undefined) {
      this.setState({
        access: false
      });
      this.props.settleAccess(false)
    } else {
      this.decodeToken(queryStringParam)
    }
  };
  decodeToken = (queryStringParam) => {
    try {
      let decode_token = JWT_Decode(queryStringParam);
      let mvid = decode_token.mvId;
      let email = decode_token.sub;
      let refid = decode_token.refNo;

      if (mvid === undefined || email === undefined || refid === undefined) {
        this.setState({
          access: false
        });
        this.props.settleAccess(false)
      } else {
        this.setState({
          token: queryStringParam,
          access: true
        })
      }
    } catch (e) {
      console.log("error", e);
      this.setState({
        access: false
      });
      this.props.settleAccess(false)
    }
  };
  isValidate = () => {
    let forward_emails = this.state.forward_emails;
    // let

    if (forward_emails.length !== 0) {
      let count = 0;
      let invalid_email_count = 0;

      forward_emails.map((email, index) => {
        if (email.value.trim() === "") {
          count++;
        }
        if (!email.condition) {
          invalid_email_count++;
        }
      });

      if (count === 0) {
        if (invalid_email_count === 0) {

          let email_array = [];
          let condition = false;

          const {forward_email} = this.state;
          forward_email.map((email, index) => {
            email_array.push(email.value.toLowerCase())
          });

          email_array.sort();
          let last = email_array[0];

          for (let i = 1; i < email_array.length; i++) {
            if (email_array[i] === last) condition = true;
            last = email_array[i];
          }

          if (!condition) {
            if (this.state.isTerms) {
              swal({
                title: "Are you sure, you want to proceed?",
                icon: are_you_sure_icon,
                closeOnClickOutside: false,
                buttons: {
                  cancel: 'Cancel',
                  dangerMode: {
                    text: "Yes",
                    value: "action",
                    className: "okay-btn"
                  }
                },
              }).then((value) => {
                switch (value) {
                  case "action":
                    this.sendToBackend(email_array);
                    break;
                  default:
                    break;
                }
              });

            } else {
              common.notifyMessage("Please accept the Terms of Service to proceed");
            }
          } else {
            common.notifyMessage("There are duplicates of some emails", 0, 3);
          }

        } else if (invalid_email_count === 1) {
          common.notifyMessage("Please enter valid email address", 0, 3);
        } else {
          common.notifyMessage("Please enter valid email addresses", 0, 3);
        }
      } else if (count === 1) {
        common.notifyMessage("You have already missed some email field", 0, 3);
      } else {
        common.notifyMessage("You have already missed some email fields", 0, 3);
      }
    }
  };
  sendToBackend = (email_array) => {
    const obj = {
      emails: email_array,
    };
    this.props.spinnerHandler(true);
    const headers = {
      "token": "Bearer " + this.state.token
    };

    axios.post(apiConfig.CORPORATE_FORWARD_MEETING, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          swal({
            title: response.data.message,
            icon: success_icon,
            closeOnClickOutside: false,
            buttons: {
              dangerMode: {
                text: "Okay",
                value: "action",
                className: "okay-btn"
              }
            },
          }).then((value) => {
            switch (value) {
              case "action":
                window.close();
                break;
              default:
                window.close();
                break;
            }
          });
        } else {
          if (response.data.error_code === 700) { //SEND_OTP_TO_VERIFY
            common.notifyMessage(response.data.message, 1);
            this.setState({
              isPin: true
            })
          } else if (response.data.error_code === 701) { //INCORRECT_OTP_SUBMITTED
            common.notifyMessage(response.data.message, 0);
            this.setState({
              isPin: true
            })
          } else {
            common.warningAlert(response.data.message, 1)
          }
        }
      })
      .catch(error => {
        if (error.response.status === 417) { //APPLICATION ERROR
          common.warningAlert("Something went wrong", 1)
        } else if (error.response.status === 403) {
          common.warningAlert(error.response.data.message, 1)
        } else {
          common.warningAlert("Something went wrong", 1)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  removeVisitor = (index, visitor) => {
    let custom_array = this.state.forward_emails;
    let email = visitor.value;

    if (email.trim() === "") {
      custom_array.splice(index, 1);
      this.setState({
        forward_emails: custom_array
      });
    } else {
      swal({
        title: "Are you sure you want to remove this participant's email? (" + email.trim() + ")",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Remove",
            value: "action",
            className: "remove-btn"
          }
        }
      })
        .then((value) => {
          switch (value) {
            case "action":
              custom_array.splice(index, 1);
              this.setState({
                forward_emails: custom_array
              });
              break;
            default:
          }
        });
    }

  };

  componentDidMount() {
    this.checkQueryString();
  }

  render() {
    return (
      <Row className={"visitor-forward-form"}>
        <Col xs={12} md={8}>
          <p className={"title required-lbl"}>Please enter valid emails of participants </p>
          {
            this.state.forward_emails.length !== 0 ?
              this.state.forward_emails.map((email, index) => {
                return <Row key={index}>
                  <Col xs={8}>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          placeholder={"Email Address"}
                          value={email.value}
                          onChange={this.handleChange(index, 'forward_email')}
                        />
                      </Form.Group>
                    </Form>
                  </Col>
                  <Col xs={4}>
                    {
                      this.state.forward_emails.length !== 1 ?
                        <SementicBtn circular icon='trash alternate' className={"more-remove-card"}
                                     onClick={() => this.removeVisitor(index, email)}/> : null
                    }

                    {
                      email.value.trim() !== "" ?
                        <label
                          className={email.condition ? "correct-txt" : "wrong-txt"}>{email.condition ? "Correct" : "Wrong"}</label> : null
                    }

                  </Col>
                </Row>
              }) : null
          }

          <Button onClick={this.addUser} type="dashed" className={"dashed-btn"}>
            <Icon size="small" name="plus"/> Add another visitor
          </Button>

          <br/><br/>
          {
            this.state.access ?
              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Checkbox style={{cursor: 'pointer'}}
                          label={<label>I accept the <a target="_blank" href={'/vms_privacy_policy'}> Terms of
                            Service </a> | <a target="_blank" href={'https://www.dialog.lk/privacy-policy'}> Privacy
                            Policy</a>.</label>}
                          onChange={() => this.setState({isTerms: !this.state.isTerms})}
                          checked={this.state.isTerms}
                />
                <br/><br/>
                <Button className="px-5" onClick={this.isValidate}>Submit</Button>
              </Col> : null
          }

        </Col>
        <Col xs={12} lg={4} md={4} style={{textAlign: 'center'}}>
          <img style={{width: '65%'}} src={regis_icon} alt={"."}/>
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(null, mapDispatchToProps)(App);
